import { render, staticRenderFns } from "./Programi.vue?vue&type=template&id=6f0ff112&"
import script from "./Programi.vue?vue&type=script&lang=js&"
export * from "./Programi.vue?vue&type=script&lang=js&"
import style0 from "./Programi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports